// extracted by mini-css-extract-plugin
module.exports = {"button":"_c57950","is-dark":"_7c618e","is-light":"_91fddd","is-new-light":"_c5b20f","signIn":"_5b21fd","signInButton":"_ab3f98","joinButton":"_b9e9d0"};